export default __webpack_public_path__ + "static/media/img-yer-4.b3716f77.png";